import { getState, getStatePure, modifyState } from '~src/state';
import { exportIMG } from '~core';
import { addPagesToSidebar } from '~src/multipages';

export const generateCurrentPageThumbnail = async () => {
  if (getState('isErasing', false)) {
    return;
  }
  if (getState('isExporting', false)) {
    return;
  }
  const isZoomed = window.canvas.getZoom();
  if (isZoomed !== 1) {
    return;
  }
  const pages = getStatePure('pages');
  const project = getState('selected.tipo');
  const currentPageIndex = getState('currentPageIndex', 0);

  if (pages.length > 0) {
    const preview = exportIMG(
      0.92,
      project.outputDpi,
      'base64',
      'jpeg',
      true,
      project.multiplier || 1
    );
    await modifyState(`pages[${currentPageIndex}].imgData`, preview.base64);
    await addPagesToSidebar();
  }
};
